class OrderProductItem {
	constructor(product_id, allotted_weight, product_name, category_name, grade, hsn_code, input_type, item_id) {
		if (typeof product_id === 'object') {
			Object.assign(this, product_id)
			this.allotted_weight = product_id.ordered_weight
			this.price_per_kg = null
			this.tc_available = this.tc_required
			this.serviced_weight = null
			return
		}

		this.allotted_weight = allotted_weight ? allotted_weight : null
		this.serviced_weight = null
		this.brand_ordered = 'ANY'
		this.product_id = product_id ? product_id : null
		this.product_name = product_name ? product_name : null
		this.category_name = category_name ? category_name : null
		this.logistics_price = null
		this.minimum_guaranteed_weight = null
		this.minimum_order_quantity = null
		this.price_per_kg = null
		this.quote_type = 'FOR'
		this.grade = grade ?? null
		this.hsn_code = hsn_code ?? null
		this.input_type = input_type ?? null
		this.item_id = item_id

		this.tc_available = true

		// add Missing keys

		this.category_id = null
		this.ordered_weight = null
		this.merged = false
		this.tax_amount = null
		this.gross_amount = null
		this.crm_po_no = null
		this.tax_details = []
		//added keys
		this.gst = null
		this.push_item_to_oracle = false
		this.pending_weight = null
	}
}

export default OrderProductItem
